import { Box, SxProps, Typography, useTheme } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import { FC } from 'react';

import { pxToRem } from '@/theme/typography';
import ImageBoxFuture from '../shared/image-box-future';

interface CreditCardsListEmptyStateProps {
  message: string;
  imgSx?: SxProps;
}

export const CreditCardsListEmptyState: FC<CreditCardsListEmptyStateProps> = ({
  message,
  imgSx,
}) => {
  const theme = useTheme();
  const intl = useIntl();

  // Paused
  return true ? (
    <> </>
  ) : (
    <Box
      id='credit-card-empty-state'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        marginBottom: {
          mobile: '24px',
          tablet: pxToRem(32),
        },
      }}
    >
      <ImageBoxFuture
        img='/icons/profile/credit-card/credit-cards-empty.svg'
        title={intl.formatMessage({
          id: 'alt.no_data_icon',
        })}
        objectFit='contain'
        sx={{
          width: {
            mobile: '150px',
            tablet: pxToRem(187),
          },
          height: {
            mobile: '125px',
            tablet: pxToRem(166),
          },
          marginBottom: {
            mobile: '24px',
            tablet: pxToRem(32),
          },
          ...imgSx,
        }}
      />

      <Typography
        component='p'
        sx={{
          fontSize: {
            mobile: '16px',
            tablet: pxToRem(20),
          },
          textAlign: 'center',
          color: theme.palette.grey[50],
          maxWidth: {
            mobile: '461px',
            tablet: pxToRem(461),
          },
          lineHeight: '150%',
        }}
      >
        <FormattedMessage id={message} />
      </Typography>
    </Box>
  );
};
